import { useEffect, useState } from 'react';
import { ArrowRightSmall, Xmark } from '@peacecover/icon';
import { t } from 'i18next';
import RainbowHeartIcon from '../../my-page/my-page-test-icon/RainbowHeartIcon';
import { useLatestNoticePostQuery } from '../../../components/api/contentful/ContentfulClient';
import saveData from '@pocapan/shared/utils/saveData';

interface LoungeBannerProps {
  onClose: () => void;
  isWishLounge: boolean;
}

const LoungeBanner = ({ onClose, isWishLounge }: LoungeBannerProps) => {
  const [isShowBanner, setIsShowBanner] = useState(false);
  const { data: latestNoticePost } = useLatestNoticePostQuery();

  const title = latestNoticePost?.fields?.content;
  const id = latestNoticePost?.sys?.id;

  useEffect(() => {
    const latestContentfulNoticeId = localStorage.getItem('latestContentfulNoticeId');
    if (latestContentfulNoticeId && latestContentfulNoticeId === id) {
      setIsShowBanner(false);
    } else {
      setIsShowBanner(true);
    }
  }, [id]);

  const handleClose = () => {
    saveData('latestContentfulNoticeId', id);
    onClose();
  };

  if (isWishLounge) {
    return (
      <div
        className="p-[1px] rounded-[12px] shadow-[0_0_4px_0_rgba(0,0,0,0.05),_0_0_11.6px_0_rgba(0,0,0,0.05)] mx-[8px]"
        style={{
          background:
            'conic-gradient(from 180deg at 50% 50%, #5CD2FF 0deg, #E37EE2 120.6000030040741deg, #FFDF76 246.60000085830688deg, #76D2B6 360deg)'
        }}
      >
        <div className="flex items-center justify-between bg-background-elevated rounded-[11px] px-[14px] py-[12px]">
          <div className="flex items-center gap-[6px]">
            <RainbowHeartIcon size={20} />
            <p className="text-[13px] font-medium text-text-main-lv3 leading-[16px]">
              {t('LoungeChatPage.onlyWishzen')}
            </p>
          </div>
          <button type="button" onClick={onClose}>
            <Xmark size={14} className="text-text-main-lv3" />
          </button>
        </div>
      </div>
    );
  }

  if (isShowBanner) {
    return (
      <div className="flex items-center justify-between bg-background-elevated rounded-[11px] pl-[16px] pr-[13px] py-[12px] shadow-[0_0_4px_0_rgba(0,0,0,0.05),_0_0_11.6px_0_rgba(0,0,0,0.05)] mx-[8px]">
        <a className="flex items-center gap-[6px]" href={`/fanhearts?path=notice&id=${id}`}>
          <img
            src="/assets/icons/star_banner_icon.png"
            alt="star banner icon"
            className="w-[20px] h-[20px]"
          />
          <p className="text-[13px] font-semibold text-on-success leading-[16px]">{title}</p>
          <ArrowRightSmall size={16} className="text-on-success" />
        </a>
        <button type="button" onClick={handleClose}>
          <Xmark size={14} className="text-text-main-lv3" />
        </button>
      </div>
    );
  }

  return null;
};

export default LoungeBanner;
